// =====================================================
// CKAN Configuration
// =====================================================
// IMPORTANTE: Si el servidor CKAN no es accesible desde internet público,
// usa MODE = 'frontend' para hacer las llamadas directamente desde el navegador.
// Esto funcionará si estás en la misma red que CKAN.
// =====================================================

export const CKAN_CONFIG = {
  // MODE: 'edge-functions' (producción) | 'frontend' (desarrollo/CKAN privado)
  // CAMBIAR AQUÍ para probar Edge Functions vs Frontend+Proxy
  MODE: 'edge-functions' as 'edge-functions' | 'frontend',

  // URL base del CKAN API - PRODUCCIÓN Diputación de Palencia
  // Si MODE = 'frontend': Usa 'http://localhost:3001' (proxy para evitar CORS)
  // Si MODE = 'edge-functions': Usa la URL directa del CKAN
  CKAN_API_URL: 'https://ckan.diputaciondepalencia.es',

  // Token JWT (usuario cesefor_1 - solo lectura)
  CKAN_API_TOKEN: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJKdzJLTkFTWXNObkRHRkJ4cVBmSEV6UTkxY1FLcHZxVTMweDFmMlJyY3lJIiwiaWF0IjoxNzYxODEwMDc4fQ.Kz947SjSJiivVeGt_Fziwki0lKT40czWVZSEW3fWmoE',
};

/**
 * Notas de Seguridad:
 *
 * 1. En MODE 'frontend':
 *    - Las llamadas se hacen directamente desde el navegador
 *    - El token es visible en el código del cliente
 *    - Requiere proxy local para evitar CORS (npm run proxy-ckan)
 *    - USAR SOLO PARA DESARROLLO/TESTING
 *
 * 2. En MODE 'edge-functions':
 *    - Las llamadas se hacen desde Supabase Edge Functions
 *    - El token está oculto (variable de entorno)
 *    - Funciona con CKAN público accesible 24/7 desde internet
 *    - RECOMENDADO PARA PRODUCCIÓN (si CKAN es público)
 *
 * 3. PROBLEMA ACTUAL - CORS:
 *    - El servidor CKAN NO permite CORS desde el navegador
 *    - Postman funciona (no valida CORS)
 *    - Navegador bloquea la respuesta (aunque el servidor responde 200 OK)
 *    - SOLUCIÓN DESARROLLO: Usar proxy local (npm run proxy-ckan)
 *    - SOLUCIÓN PRODUCCIÓN: Configurar CORS en el servidor CKAN o usar Edge Functions
 *
 * 4. Para Producción:
 *    - Mover CKAN_API_TOKEN a variable de entorno (.env)
 *    - Opción A: Configurar CORS en CKAN + MODE 'frontend'
 *    - Opción B: Asegurar CKAN 24/7 público + MODE 'edge-functions'
 */
